import {
    Box,
    Card,
    Button,
    Chip,
    Grid2,
    Typography,
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    Snackbar,
    Container,
    Paper,
    Divider,
    Stack,
    Breadcrumbs,
    Link
} from "@mui/material"
import { Carousel } from "react-responsive-carousel"
import BedIcon from "@mui/icons-material/Bed";
import CropSquareIcon from "@mui/icons-material/CropSquare";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import HomeIcon from '@mui/icons-material/Home';
import PhoneIcon from '@mui/icons-material/Phone';
import { ImageWithFallback } from "./product";
import { Dialogue } from "./Dialogue";
import { useState } from "react";
import FreeValuationForm from "../BookEvaluation";
import MapField from "./MapField";
import ArrangeViewing from "../ArrangeViewing";
import ShareIcon from '@mui/icons-material/Share';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import FacebookIcon from '@mui/icons-material/Facebook';
import EmailIcon from '@mui/icons-material/Email';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CloseIcon from '@mui/icons-material/Close';
import VerifiedIcon from '@mui/icons-material/Verified';
import FavoriteIcon from '@mui/icons-material/Favorite';
import { openWhatsAppChatForProperty } from "../../util/whatsappUtils";
import { useFavorite } from "../../util/useFavorite";
import InvertedImg from '../../assets/img/Inverted9.svg'

export const PropertyDetailsCard = (props) => {
    const { hideRightSidebar = false, propertyType } = props;

    // Helper function to check if property is agricultural
    const isAgriculturalProperty = () => {
        const explicitType = (propertyType || props?.property?.propertyType || props?.property?.type || props?.property?.propertyCategory)?.toLowerCase();
        const areaUnit = props?.property?.area?.unit?.toLowerCase();

        return explicitType === 'agricultural' || areaUnit === 'hectares' || areaUnit === 'acres';
    };
    const [openEvaluation, setOpenEvaluation] = useState(false);
    const [openViewing, setOpenViewing] = useState(false);
    const [openShareDialog, setOpenShareDialog] = useState(false);
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [isMenuOpen, setMenuOpen] = useState(false);
    const [showCallConfirmation, setShowCallConfirmation] = useState(false);

    // Get property ID for favorites
    const propertyId = props?.property?._id || props?.property?.id || props?.property?.propertyId || props?.property?.ID;

    // Normalize contact number (prefer property-level contact fields)
    const contactNumber = props?.property?.contactNumber || props?.property?.phone || props?.property?.phoneNumber || props?.property?.agentPhone || props?.property?.ownerPhone || props?.property?.mobile || '';

    // Use custom favorite hook
    const { isFavorite, handleFavoriteToggle } = useFavorite(propertyId);



    const toggleMenu = () => {
        setMenuOpen(!isMenuOpen);
    };

    const handleFavoriteClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        handleFavoriteToggle(e);
    };

    const formatCurrency = (amount) => {
        if (!amount) return "₹ Contact for Price";

        // If it's already a string with text (alphanumeric), return as is or prepend ₹ if needed
        if (typeof amount === 'string' && isNaN(amount)) {
            if (amount.includes('₹') || amount.includes('£')) return amount;
            return `₹ ${amount}`;
        }

        const num = Number(amount);
        if (isNaN(num)) return amount;

        let local = props.property.country === 'United Kingdom' ? "en-GB" : "en-IN";
        let currency = props.property.country === 'United Kingdom' ? "GBP" : "INR";
        return new Intl.NumberFormat(local, {
            style: "currency",
            currency,
            minimumFractionDigits: 0,
        }).format(num);
    };

    const getRandomImages = (images, count) => {
        if (images.length <= count) return images;
        const shuffled = [...images].sort(() => 0.5 - Math.random());
        return shuffled.slice(0, count);
    };

    // Format area: support numeric or object like { value, unit }
    const formatAreaValue = (val, fallback) => {
        const v = val ?? fallback;
        if (v === null || v === undefined || v === '') return '';
        if (typeof v === 'object') {
            const num = v?.value ?? v?.val ?? '';
            const unit = v?.unit ?? v?.measurement ?? '';
            if (num !== '' && num !== null && num !== undefined) return `${num} ${unit}`.trim();
            return JSON.stringify(v);
        }
        if (!Number.isNaN(Number(v))) return `${Number(v)} Sq Ft`;
        return String(v);
    };

    const handleShare = () => {
        setOpenShareDialog(true);
    };

    const handleClose = () => {
        setOpenShareDialog(false);
    };

    const shareUrl = window.location.href;

    const handleWhatsAppShare = () => {
        window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(shareUrl)}`, '_blank');
    };

    const handleFacebookShare = () => {
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`, '_blank');
    };

    const handleEmailShare = () => {
        window.open(`mailto:?subject=Check out this property&body=${encodeURIComponent(shareUrl)}`);
    };

    const handleCopyLink = () => {
        navigator.clipboard.writeText(shareUrl);
        setOpenSnackbar(true);
        handleClose();
    };

    const handleCallClick = (e) => {
        if (e) e.preventDefault();
        setShowCallConfirmation(true);
    };

    const handleConfirmCall = () => {
        const phoneNumber = '917893092211';
        const whatsappCallUrl = `https://wa.me/${phoneNumber}?call=1`;
        window.open(whatsappCallUrl, '_blank');
        setShowCallConfirmation(false);
    };

    return (
        <Container
            maxWidth="lg"
            sx={{
                px: { xs: 0, sm: 1, md: 0 },
                width: '100%',
                maxWidth: '100%',
                overflow: 'hidden'
            }}
            fluid
        >
            {/* Breadcrumb Navigation Box - Exact Design Match */}
            <Paper
                elevation={0}
                sx={{
                    backgroundColor: '#f2f2f2',
                    // border: '1px solid #e9ecef',
                    borderRadius: 0,
                    // p: 2,
                    px: { xs: 0.5, sm: 2 },
                    py: 1,
                    mb: 0,
                    width: '100%',
                    overflow: 'hidden'
                }}
            >
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    flexDirection: 'row',
                    gap: 1,
                    minHeight: '48px'
                }}>
                    {/* Left side - Breadcrumb */}
                    <Box sx={{
                        flex: 1,
                        overflow: 'hidden',
                        minWidth: 0
                    }}>
                        <Breadcrumbs
                            separator="›"
                            sx={{
                                mb: 0,
                                '& ol': {
                                    listStyle: 'none !important',
                                    padding: 0,
                                    margin: 0,
                                    flexWrap: 'nowrap',
                                    overflow: 'hidden'
                                },
                                '& ol li::before': {
                                    content: '""',
                                    counterIncrement: 'none !important',
                                    marginRight: 0,
                                    listStyle: 'none !important',
                                },
                                '& li': {
                                    listStyle: 'none !important',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    minWidth: 0
                                },
                                '& .MuiBreadcrumbs-separator': {
                                    color: '#6c757d',
                                    mx: 0.5,
                                    flexShrink: 0
                                },
                            }}
                        >
                            <Link
                                underline="hover"
                                color="#d8b035 !important"
                                href="/"
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    fontSize: { xs: '0.75rem', sm: '0.875rem' },
                                    minWidth: 0,
                                    '&:hover': { color: '#d8b035', color: '#d8b035 !important' }
                                }}
                            >
                                <HomeIcon sx={{ mr: 0.5, fontSize: { xs: '0.875rem', sm: '1rem' }, color: "#d8b035", flexShrink: 0 }} />
                                <Box component="span" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                    Home
                                </Box>
                            </Link>
                            <Link
                                underline="hover"
                                color="#d8b035 !important"
                                href="/commercial-plots-for-sale-in-amaravati"
                                sx={{
                                    fontSize: { xs: '0.75rem', sm: '0.875rem' },
                                    minWidth: 0,
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    '&:hover': { color: '#d8b035', }
                                }}
                            >
                                {props?.property?.propertyType || props?.property?.type || ''}
                            </Link>
                            <Typography
                                color="#495057"
                                sx={{
                                    fontSize: { xs: '0.75rem', sm: '0.875rem' },
                                    fontWeight: 500,
                                    display: { xs: 'none', md: 'block' },
                                    minWidth: 0,
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap'
                                }}
                            >
                                {props?.property?.title || props?.property?.name || ''}
                            </Typography>
                        </Breadcrumbs>
                    </Box>

                    {/* Right side - Action Icons */}
                    <Box sx={{
                        display: 'flex',
                        gap: 1,
                        flexShrink: 0,
                        ml: 1
                    }}>
                        <IconButton
                            size="small"
                            onClick={handleShare}
                            sx={{
                                border: '1px solid #dee2e6',
                                borderRadius: '4px',
                                backgroundColor: 'white',
                                minWidth: { xs: '32px', sm: '40px' },
                                width: { xs: '32px', sm: '40px' },
                                height: { xs: '32px', sm: '40px' },
                                '&:hover': { backgroundColor: '#f8f9fa' }
                            }}
                        >
                            <ShareIcon fontSize="small" />
                        </IconButton>
                        <IconButton
                            size="small"
                            onClick={handleFavoriteClick}
                            sx={{
                                border: '1px solid #dee2e6',
                                borderRadius: '4px',
                                backgroundColor: 'white',
                                minWidth: { xs: '32px', sm: '40px' },
                                width: { xs: '32px', sm: '40px' },
                                height: { xs: '32px', sm: '40px' },
                                color: isFavorite ? 'red' : '#666',
                                '&:hover': {
                                    backgroundColor: '#f8f9fa',
                                    color: 'red'
                                },
                                transition: 'color 0.3s ease, transform 0.2s',
                                '&:active': { transform: 'scale(1.2)' }
                            }}
                        >
                            <FavoriteIcon fontSize="small" />
                        </IconButton>
                    </Box>
                </Box>
            </Paper>

            {/* Property Title Section */}
            <Paper
                elevation={0}
                sx={{
                    backgroundColor: '#f2f2f2',
                    border: '1px solid #e9ecef',
                    borderTop: 0,
                    borderRadius: 0,
                    // p: 3,
                    px: { xs: 0.5, sm: 2 },
                    py: { xs: 2, sm: 3 },
                    mb: 3,
                    width: '100%',
                    overflow: 'hidden'
                }}
            >
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexDirection: { xs: 'column', md: 'row' }, gap: { xs: 2, md: 0 } }}>
                    {/* Left side - Title and Location */}
                    <Box sx={{ flex: 1 }}>
                        <Typography
                            variant="h4"
                            component="h1"
                            sx={{
                                fontWeight: 'bold',
                                color: '#212529',
                                mb: 1,
                                fontSize: { xs: '1.25rem', sm: '1.5rem', md: '2rem' },
                                wordBreak: 'break-word',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                display: '-webkit-box',
                                WebkitLineClamp: { xs: 2, sm: 3 },
                                WebkitBoxOrient: 'vertical'
                            }}
                        >
                            {props?.property?.title || props?.property?.name || ''}
                        </Typography>

                        <Box sx={{ display: "flex", alignItems: "center", color: "#6c757d", mb: 0 }} >
                            <LocationOnIcon fontSize="small" sx={{ color: "#6c757d", mr: 0.5 }} />
                            <Typography variant="body1" sx={{ color: '#6c757d' }}>
                                {props?.property?.address || props?.property?.location || '-'}
                            </Typography>
                        </Box>
                    </Box>

                    {/* Right side - Call to Action */}
                    <Box
                        sx={{
                            textAlign: { xs: 'center', md: 'right' },
                            minWidth: { md: '200px' },
                            display: "flex",
                            flexDirection: { xs: 'row', md: 'column' },
                            alignItems: { xs: 'center', md: 'flex-end' },
                            gap: { xs: 0.5, md: 0 },
                            width: { xs: '100%', md: 'auto' },
                            justifyContent: { xs: 'flex-start', md: 'flex-end' },
                            flexWrap: 'wrap',
                            overflow: 'hidden',
                            cursor: 'pointer'
                        }}
                        onClick={handleCallClick}
                    >
                        <Typography
                            variant="body1"
                            sx={{
                                color: '#d8b035',
                                fontWeight: 600,
                                // mb: 0.5,
                                fontSize: { xs: '0.85rem', sm: '0.95rem' },
                                display: { xs: 'block', sm: 'block' }
                            }}
                        >
                            For the Latest Rates -
                        </Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: { xs: 'center', md: 'flex-end' }, gap: 0.5 }}>
                            <PhoneIcon sx={{ fontSize: 18, color: '#dc3545' }} />
                            <Typography
                                variant="body1"
                                sx={{
                                    color: '#dc3545',
                                    fontWeight: 'bold',
                                    fontSize: { xs: '0.85rem', sm: '0.95rem' }
                                }}
                            >
                                Call Now!
                            </Typography>
                        </Box>
                    </Box>
                </Box>
            </Paper>

            {/* Main Content */}
            <Grid2
                container
                spacing={{ xs: 1, sm: 2, md: 4 }}
                sx={{
                    width: '100%',
                    margin: 0,
                    '& > .MuiGrid2-root': {
                        paddingLeft: { xs: '4px', sm: '8px', md: '16px' },
                        paddingTop: { xs: '4px', sm: '8px', md: '16px' }
                    }
                }}
            >
                {/* Left Column - Property Details */}
                <Grid2 size={{ xs: 12, md: hideRightSidebar ? 12 : 8 }}>
                    {/* Property Status Chips */}
                    <Box sx={{ mb: 3 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap', justifyContent: { xs: 'flex-start', sm: 'flex-start' } }}>
                            {(() => {
                                const isFeatured = Boolean(props?.property?.featured || props?.property?.isFeatured || props?.property?.featuredProperty || props?.property?.is_featured);
                                const isStatusActive = (props?.property?.status || '').toLowerCase() === 'active';
                                if (isFeatured && isStatusActive) {
                                    return (
                                        <Chip
                                            label="FEATURED"
                                            size="small"
                                            sx={{
                                                backgroundColor: '#4caf50',
                                                color: "white",
                                                fontWeight: "bold",
                                                borderRadius: '4px'
                                            }}
                                        />
                                    );
                                }
                                return null;
                            })()}
                            <Chip
                                label={props?.property?.propertyStatus?.toUpperCase() || props?.property?.status?.toUpperCase() || 'FOR SALE'}
                                size="small"
                                sx={{
                                    backgroundColor: (() => {
                                        const ps = (props?.property?.propertyStatus || '').toLowerCase();
                                        if (ps === 'rented' || ps === 'sold') return '#f44336';
                                        if (ps === 'for rent') return '#2196f3';
                                        return '#333';
                                    })(),
                                    color: "white",
                                    fontWeight: "bold",
                                    borderRadius: '4px'
                                }}
                            />
                            {props.property.country === "India" && (
                                <Chip
                                    icon={<VerifiedIcon sx={{ color: "#fff !important" }} />}
                                    label="Verified"
                                    size="small"
                                    sx={{
                                        backgroundColor: "green",
                                        color: "#fff",
                                        fontWeight: "bold",
                                        borderRadius: '4px'
                                    }}
                                />
                            )}
                        </Box>
                    </Box>

                    {/* Property Image */}
                    <Card sx={{ mb: 4, borderRadius: '8px', overflow: 'hidden' }}>
                        <Box sx={{ position: "relative" }}>
                            <Carousel showThumbs={false} infiniteLoop showStatus={false} autoPlay>
                                {props?.property?.images?.length > 0 && props?.property?.images?.map((image, index) => (
                                    <Box key={index} sx={{ height: { xs: '250px', sm: '300px', md: '400px' } }}>
                                        <ImageWithFallback
                                            src={image}
                                            alt={`Property ${index + 1}`}
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                objectFit: 'cover'
                                            }}
                                        />
                                    </Box>
                                ))}
                            </Carousel>
                        </Box>
                    </Card>

                    {/* Quick Property Information */}
                    <Paper sx={{ p: { xs: 2, sm: 3 }, mb: 4, borderRadius: '8px' }}>
                        <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
                            Quick Property Information
                        </Typography>

                        <Grid2
                            container
                            spacing={{ xs: 1, sm: 2, md: 3 }}
                            sx={{
                                width: '100%',
                                margin: 0,
                                '& > .MuiGrid2-root': {
                                    paddingLeft: { xs: '4px', sm: '8px' },
                                    paddingTop: { xs: '4px', sm: '8px' }
                                }
                            }}
                        >
                            <Grid2 size={{ xs: 6, sm: 6, md: 3 }}>
                                <Box sx={{ textAlign: 'center' }}>
                                    <CropSquareIcon sx={{ color: "#d8b035", fontSize: 32, mb: 1 }} />
                                    <Typography variant="body2" color="text.secondary">
                                        Plot Size
                                    </Typography>
                                    <Typography variant="h6" sx={{
                                        fontWeight: 'bold',
                                        fontSize: { xs: '0.9rem', sm: '1rem', md: '1.25rem' },
                                        wordBreak: 'break-word',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap'
                                    }}>
                                        {formatAreaValue(props?.property?.area, props?.property?.landSize) || '-'}
                                    </Typography>
                                </Box>
                            </Grid2>

                            {/* Facing - Hide for agricultural properties */}
                            {!isAgriculturalProperty() && (
                                <Grid2 size={{ xs: 6, sm: 6, md: 3 }}>
                                    <Box sx={{ textAlign: 'center' }}>
                                        <LocationOnIcon sx={{ color: "#d8b035", fontSize: 32, mb: 1 }} />
                                        <Typography variant="body2" color="text.secondary">
                                            Facing
                                        </Typography>
                                        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                                            {props?.property?.facing || '-'}
                                        </Typography>
                                    </Box>
                                </Grid2>
                            )}

                            {(props?.property?.propertyType || props?.property?.type) !== 'Office' && (
                                <Grid2 size={{ xs: 6, sm: 6, md: 3 }}>
                                    <Box sx={{ textAlign: 'center' }}>
                                        <BedIcon sx={{ color: "#d8b035", fontSize: 32, mb: 1 }} />
                                        <Typography variant="body2" color="text.secondary">
                                            {props?.property?.bhkType ? 'BHK' : (props?.property?.bedrooms ? 'Bedrooms' : 'Area')}
                                        </Typography>
                                        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                                            {props?.property?.bhkType ? props?.property?.bhkType : (props?.property?.bedrooms ? props?.property?.bedrooms : (formatAreaValue(props?.property?.area, props?.property?.landSize) || '-'))}
                                        </Typography>
                                    </Box>
                                </Grid2>
                            )}

                            <Grid2 size={{ xs: 6, sm: 6, md: 3 }}>
                                <Box sx={{ textAlign: 'center' }}>
                                    <Typography variant="h6" sx={{ color: "#d8b035", mb: 1 }}>
                                        ₹₹
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        BEST DEALS
                                    </Typography>
                                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                                        {formatCurrency(props?.property?.price || props?.property?.rentOrPrice)}
                                    </Typography>
                                </Box>
                            </Grid2>
                        </Grid2>
                    </Paper>

                    {/* Description */}
                    <Paper sx={{ p: { xs: 2, sm: 3 }, mb: 4, borderRadius: '8px' }}>
                        <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
                            Description
                        </Typography>
                        <Typography
                            variant="body1"
                            sx={{
                                color: "#6c757d",
                                lineHeight: 1.6
                            }}
                            dangerouslySetInnerHTML={{ __html: props?.property?.description }}
                        />

                        {props?.property?.features && (
                            <Box sx={{ mt: 3 }}>
                                <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
                                    Features
                                </Typography>
                                <Typography
                                    variant="body1"
                                    sx={{
                                        color: "#6c757d",
                                        lineHeight: 1.6
                                    }}
                                    dangerouslySetInnerHTML={{ __html: props?.property?.features }}
                                />
                            </Box>
                        )}

                        {props?.property?.amenities && props?.property?.amenities.length > 0 && (
                            <Box sx={{ mt: 3 }}>
                                <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
                                    Amenities
                                </Typography>
                                <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                                    {props.property.amenities.map((a, i) => (
                                        <Chip key={i} label={a} size="small" sx={{ backgroundColor: '#f1f1f1', borderRadius: '4px', color: '#333', fontWeight: 500 }} />
                                    ))}
                                </Box>
                            </Box>
                        )}
                    </Paper>

                    {/* Map */}
                    {/* Determine coordinates from multiple possible fields and show them as label */}
                    {(!hideRightSidebar) && (
                        (() => {
                            const ml = props?.property?.mapLong || {};
                            const coordsFromMapLong = (ml?.lat && ml?.lng) ? { lat: ml.lat, lng: ml.lng } : (ml?.latitude && ml?.longitude) ? { lat: ml.latitude, lng: ml.longitude } : null;
                            const c = props?.property?.coordinates || props?.property?.coords || {};
                            const coordsFromCoordinates = (c?.latitude && c?.longitude) ? { lat: c.latitude, lng: c.longitude } : (c?.lat && c?.lng) ? { lat: c.lat, lng: c.lng } : null;
                            const finalCoords = coordsFromMapLong || coordsFromCoordinates || null;

                            // Use a static label for the map header
                            const coordLabel = 'Location';

                            return finalCoords ? (
                                <Paper sx={{ p: { xs: 2, sm: 3 }, mb: 4, borderRadius: '8px' }}>
                                    {/* <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>
                                        {coordLabel}
                                    </Typography> */}
                                    {/* <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                                        {`${finalCoords.lat}, ${finalCoords.lng}`}
                                    </Typography> */}
                                    <MapField label={coordLabel} coordinates={finalCoords} />
                                </Paper>
                            ) : null;
                        })()
                    )}

                    {/* ECE Documents */}
                    {/* {props?.property?.eceDocument && (
                        <Paper sx={{ p: { xs: 2, sm: 3 }, mb: 4, borderRadius: '8px' }}>
                            <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
                                Documents
                            </Typography>
                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                <Button
                                    variant="contained"
                                    sx={{
                                        backgroundColor: "#d8b035",
                                        '&:hover': { backgroundColor: '#c5a02f' },
                                        borderRadius: '4px'
                                    }}
                                    onClick={() => window.open(props?.property?.eceDocument, '_blank')}
                                >
                                    View ECE
                                </Button>
                                <Button
                                    variant="outlined"
                                    sx={{
                                        borderColor: "#d8b035",
                                        color: "#d8b035",
                                        '&:hover': {
                                            backgroundColor: '#d8b035',
                                            color: 'white'
                                        },
                                        borderRadius: '4px'
                                    }}
                                    onClick={async () => {
                                        const fileUrl = props?.property?.eceDocument?.replace("http://", "https://");
                                        if (!fileUrl) return;

                                        try {
                                            const response = await fetch(fileUrl, { mode: 'cors' });
                                            const blob = await response.blob();
                                            const blobUrl = window.URL.createObjectURL(blob);

                                            const link = document.createElement('a');
                                            link.href = blobUrl;
                                            link.setAttribute('download', 'ece-document.pdf');
                                            document.body.appendChild(link);
                                            link.click();
                                            document.body.removeChild(link);
                                            window.URL.revokeObjectURL(blobUrl);
                                        } catch (error) {
                                            console.error("Failed to download file:", error);
                                        }
                                    }}
                                >
                                    Download ECE
                                </Button>
                            </Stack>
                        </Paper>
                    )} */}
                </Grid2>

                {/* Right Column - Contact Form */}
                {!hideRightSidebar && (
                    <Grid2 size={{ xs: 12, md: 4 }}>
                        <Paper
                            sx={{
                                p: { xs: 2, sm: 3 },
                                borderRadius: '8px',
                                position: { md: 'sticky' },
                                top: 20,
                                mb: { xs: 4, md: 0 }
                            }}
                        >
                            {/* Royale Spaces Logo/Header */}
                            <Box sx={{ textAlign: 'center', mb: 3 }}>
                                <Link to="/" onClick={toggleMenu}
                                    href="/"
                                    sx={{
                                        display: 'inline-block',
                                        textDecoration: 'none'
                                    }}
                                >
                                    <img
                                        src={InvertedImg}
                                        alt="Royale Spaces Logo"
                                        style={{
                                            // maxWidth: '150px',
                                            height: 'auto',
                                            width: '100%',
                                            maxWidth: '200px'
                                        }}
                                    />
                                </Link>
                            </Box>

                            <Divider sx={{ mb: 3 }} />

                            {/* Contact Form */}
                            <Stack spacing={2}>
                                <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1, fontSize: { xs: '1.1rem', sm: '1.25rem' } }}>
                                    Interested in this property?
                                </Typography>

                                <Button
                                    variant="contained"
                                    fullWidth
                                    sx={{
                                        backgroundColor: "#d8b035",
                                        '&:hover': { backgroundColor: '#d8b035' },
                                        py: 1.5,
                                        borderRadius: '4px'
                                    }}
                                >
                                    Send Message
                                </Button>

                                <Button
                                    variant="outlined"
                                    fullWidth
                                    startIcon={<PhoneIcon />}
                                    sx={{
                                        borderColor: "#d8b035",
                                        color: "#d8b035",
                                        '&:hover': {
                                            backgroundColor: '#d8b035',
                                            color: 'white'
                                        },
                                        py: 1.5,
                                        borderRadius: '4px'
                                    }}
                                    onClick={handleCallClick}
                                >
                                    Call
                                </Button>

                                <Button
                                    variant="outlined"
                                    fullWidth
                                    startIcon={<WhatsAppIcon />}
                                    sx={{
                                        borderColor: "#d8b035",
                                        color: "#d8b035",
                                        '&:hover': {
                                            backgroundColor: '#d8b035',
                                            color: 'white'
                                        },
                                        py: 1.5,
                                        borderRadius: '4px'
                                    }}
                                    onClick={() => openWhatsAppChatForProperty(props.property)}
                                >
                                    WhatsApp
                                </Button>

                                <Button
                                    variant="contained"
                                    fullWidth
                                    onClick={() => setOpenViewing(true)}
                                    sx={{
                                        backgroundColor: "#d8b035",
                                        '&:hover': { backgroundColor: '#c5a02f' },
                                        py: 1.5,
                                        borderRadius: '4px'
                                    }}
                                >
                                    Arrange Viewing
                                </Button>
                            </Stack>

                            <Divider sx={{ my: 3 }} />

                            {/* Share Options */}
                            <Box>
                                <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2, fontSize: { xs: '1.1rem', sm: '1.25rem' } }}>
                                    Share Property
                                </Typography>
                                <Button
                                    variant="outlined"
                                    fullWidth
                                    startIcon={<ShareIcon />}
                                    onClick={handleShare}
                                    sx={{
                                        borderColor: "#d8b035",
                                        color: "#d8b035",
                                        '&:hover': {
                                            backgroundColor: '#d8b035',
                                            color: 'white'
                                        },
                                        borderRadius: '4px'
                                    }}
                                >
                                    Share Options
                                </Button>
                            </Box>

                            {/* Property Gallery Thumbnails */}
                            {props?.property?.images?.length > 0 && (
                                <Box sx={{
                                    mt: 3,
                                    display: { xs: 'none', sm: 'block' }
                                }}>
                                    <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2, fontSize: { xs: '1.1rem', sm: '1.25rem' } }}>
                                        Property Gallery
                                    </Typography>
                                    <Grid2 container spacing={1}>
                                        {getRandomImages(props.property.images, 4).map((image, index) => (
                                            <Grid2 size={6} key={index}>
                                                <Box sx={{
                                                    width: '100%',
                                                    height: '80px',
                                                    overflow: 'hidden',
                                                    borderRadius: '4px',
                                                    cursor: 'pointer'
                                                }}>
                                                    <img
                                                        src={image}
                                                        alt={`Gallery ${index + 1}`}
                                                        style={{
                                                            width: '100%',
                                                            height: '100%',
                                                            objectFit: 'cover'
                                                        }}
                                                    />
                                                </Box>
                                            </Grid2>
                                        ))}
                                    </Grid2>
                                </Box>
                            )}
                        </Paper>
                    </Grid2>
                )}
            </Grid2>

            {/* Dialogs and Modals */}
            {
                openEvaluation && (
                    <Dialogue open={openEvaluation} onClose={setOpenEvaluation}>
                        <FreeValuationForm onClose={setOpenEvaluation} />
                    </Dialogue>
                )
            }

            {
                openViewing && (
                    <Dialogue open={openViewing} onClose={() => setOpenViewing(false)}>
                        <ArrangeViewing isSubmitted={setOpenViewing} />
                    </Dialogue>
                )
            }

            <Dialog
                open={openShareDialog}
                onClose={handleClose}
                maxWidth="md"
                fullWidth
                sx={{
                    '& .MuiDialog-paper': {
                        margin: { xs: 0.5, sm: 2 },
                        width: { xs: 'calc(100vw - 8px)', sm: 'auto' },
                        maxWidth: { xs: 'calc(100vw - 8px)', sm: '600px' },
                        overflow: 'hidden'
                    }
                }}
            >
                <DialogTitle sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    borderBottom: '1px solid #e0e0e0',
                    padding: { xs: '12px 16px', sm: '16px 24px' },
                    marginBottom: 2,
                    fontWeight: 'bold',
                }}>
                    Share Property
                    <IconButton onClick={handleClose} size="small">
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{ padding: { xs: 1, sm: 2, md: 3 }, overflow: 'hidden' }}>
                    <Grid2
                        container
                        spacing={{ xs: 1, sm: 2 }}
                        sx={{
                            width: '100%',
                            margin: 0,
                            '& > .MuiGrid2-root': {
                                paddingLeft: { xs: '4px', sm: '8px' },
                                paddingTop: { xs: '4px', sm: '8px' }
                            }
                        }}
                    >
                        <Grid2 size={{ xs: 12, sm: 6 }}>
                            <Box
                                onClick={handleCopyLink}
                                sx={{
                                    border: '1px solid #e0e0e0',
                                    borderRadius: 1,
                                    padding: { xs: '12px 16px', sm: '16px 24px' },
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'flex-start',
                                    cursor: 'pointer',
                                    height: '100%',
                                    minHeight: { xs: '60px', sm: '80px' },
                                    transition: 'all 0.2s ease',
                                    overflow: 'hidden',
                                    '&:hover': {
                                        backgroundColor: '#f5f5f5',
                                        borderColor: '#d8b035'
                                    }
                                }}
                            >
                                <ContentCopyIcon sx={{ color: '#666', fontSize: { xs: 24, sm: 28 }, marginRight: { xs: 2, sm: 3 }, flexShrink: 0 }} />
                                <Typography variant="body1" sx={{ fontSize: { xs: '0.875rem', sm: '1rem' }, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>Copy Link</Typography>
                            </Box>
                        </Grid2>
                        <Grid2 size={{ xs: 12, sm: 6 }}>
                            <Box
                                onClick={handleWhatsAppShare}
                                sx={{
                                    border: '1px solid #e0e0e0',
                                    borderRadius: 1,
                                    padding: '16px 24px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'flex-start',
                                    cursor: 'pointer',
                                    height: '100%',
                                    transition: 'all 0.2s ease',
                                    '&:hover': {
                                        backgroundColor: '#f5f5f5',
                                        borderColor: '#d8b035'
                                    }
                                }}
                            >
                                <WhatsAppIcon sx={{ color: '#25D366', fontSize: 28, marginRight: 3 }} />
                                <Typography variant="body1">Share via WhatsApp</Typography>
                            </Box>
                        </Grid2>
                        <Grid2 size={{ xs: 12, sm: 6 }}>
                            <Box
                                onClick={handleFacebookShare}
                                sx={{
                                    border: '1px solid #e0e0e0',
                                    borderRadius: 1,
                                    padding: '16px 24px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'flex-start',
                                    cursor: 'pointer',
                                    height: '100%',
                                    transition: 'all 0.2s ease',
                                    '&:hover': {
                                        backgroundColor: '#f5f5f5',
                                        borderColor: '#d8b035'
                                    }
                                }}
                            >
                                <FacebookIcon sx={{ color: '#4267B2', fontSize: 28, marginRight: 3 }} />
                                <Typography variant="body1">Share on Facebook</Typography>
                            </Box>
                        </Grid2>
                        <Grid2 size={{ xs: 12, sm: 6 }}>
                            <Box
                                onClick={handleEmailShare}
                                sx={{
                                    border: '1px solid #e0e0e0',
                                    borderRadius: 1,
                                    padding: '16px 24px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'flex-start',
                                    cursor: 'pointer',
                                    height: '100%',
                                    transition: 'all 0.2s ease',
                                    '&:hover': {
                                        backgroundColor: '#f5f5f5',
                                        borderColor: '#d8b035'
                                    }
                                }}
                            >
                                <EmailIcon sx={{ color: '#EA4335', fontSize: 28, marginRight: 3 }} />
                                <Typography variant="body1">Share via Email</Typography>
                            </Box>
                        </Grid2>
                    </Grid2>
                </DialogContent>
            </Dialog>

            <Snackbar
                open={openSnackbar}
                autoHideDuration={3000}
                onClose={() => setOpenSnackbar(false)}
                message="Link copied to clipboard"
            />

            {/* Same Call Confirmation Dialog as Commercial Component */}
            {showCallConfirmation && (
                <Box
                    sx={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0,0,0,0.5)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 9999,
                    }}
                    onClick={(e) => {
                        e.stopPropagation();
                        setShowCallConfirmation(false);
                    }}
                >
                    <Box
                        sx={{
                            backgroundColor: 'white',
                            borderRadius: '12px',
                            padding: 0,
                            maxWidth: '400px',
                            width: '90%',
                            boxShadow: '0 20px 40px rgba(0, 0, 0, 0.2)',
                            animation: 'slideIn 0.3s ease-out',
                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <style>{`
                            @keyframes slideIn {
                                from {
                                    opacity: 0;
                                    transform: translateY(-20px);
                                }
                                to {
                                    opacity: 1;
                                    transform: translateY(0);
                                }
                            }
                        `}</style>
                        <Box
                            sx={{
                                backgroundColor: '#d8b035',
                                color: 'white',
                                padding: '20px',
                                borderRadius: '12px 12px 0 0',
                                textAlign: 'center',
                            }}
                        >
                            <Typography variant="h6" sx={{ fontWeight: 600, m: 0 }}>Confirm Call Request</Typography>
                        </Box>
                        <Box sx={{ padding: '25px', textAlign: 'center' }}>
                            <Typography sx={{ mb: 2, color: '#333', lineHeight: 1.5 }}>
                                Would you like to make a direct call to <br /><strong>+91-7893092211</strong> via WhatsApp?
                            </Typography>
                            <Typography sx={{ color: '#666', fontSize: '14px' }}>
                                This will open WhatsApp and initiate a call to our team.
                            </Typography>
                        </Box>
                        <Box
                            sx={{
                                padding: '0 25px 25px 25px',
                                display: 'flex',
                                gap: '15px',
                                justifyContent: 'center',
                            }}
                        >
                            <Button
                                variant="outlined"
                                sx={{
                                    color: '#666',
                                    borderColor: '#ddd',
                                    textTransform: 'none',
                                    flex: 1,
                                    '&:hover': { backgroundColor: '#f5f5f5', borderColor: '#ccc' }
                                }}
                                onClick={() => setShowCallConfirmation(false)}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                startIcon={<WhatsAppIcon />}
                                sx={{
                                    backgroundColor: '#d8b035',
                                    textTransform: 'none',
                                    flex: 1,
                                    '&:hover': { backgroundColor: '#c19b2e' }
                                }}
                                onClick={handleConfirmCall}
                            >
                                Yes, Call
                            </Button>
                        </Box>
                    </Box>
                </Box>
            )}
        </Container >
    )
}